import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  TextField,
  Typography,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  useMediaQuery,
  useTheme
} from "@mui/material";
import { transfer } from "../../../../../../services/pos/Tables";
import { fetchUserBanks } from "../../../../../../services/Users";

const TransfermonyModal = ({ open, onClose, from_bank_id, bank, onSuccess }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [formData, setFormData] = useState({
    from_bank_id: from_bank_id || "",
    to_bank_id: "",
    amount: "",
    transfer_title: "",
    transfer_description: "",
    transaction_date: "",
    root_id: "",
  });

  const [banks, setBanks] = useState([]);

  useEffect(() => {
    // جلب user_id من localStorage وتمريره للدالة
    const loadBanks = async () => {
      try {
        const userId = localStorage.getItem("user_id");
        const data = await fetchUserBanks(userId);
        setBanks(data || []);
      } catch (error) {
        // تجاهل الخطأ
      }
    };
    loadBanks();
  }, []);

  useEffect(() => {
    if (from_bank_id) {
      setFormData((prev) => ({
        ...prev,
        from_bank_id: from_bank_id,
      }));
    }
  }, [from_bank_id]);

  useEffect(() => {
    if (open) {
      setFormData({
        from_bank_id: from_bank_id || "",
        to_bank_id: "",
        amount: "",
        transfer_title: "",
        transfer_description: "",
        transaction_date: "",
        root_id: "",
      });
    }
  }, [open, from_bank_id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    const payload = {
      ...formData,
      from_bank_id: from_bank_id || "",
      root_id: formData.root_id || "",
    };

    const { amount, transfer_title, transaction_date, to_bank_id } = payload;

    if (!amount || !transfer_title || !transaction_date || !to_bank_id) {
      alert("❌ يرجى ملء جميع الحقول المطلوبة.");
      return;
    }

    try {
      await transfer(payload);
      alert("✅ تم تسجيل عملية الترحيل بنجاح.");
      onSuccess?.();
      onClose?.();
    } catch (error) {
      alert(`❌ فشل في عملية الترحيل:\n${error?.message || ""}\n${error?.error || ""}`);
    }
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="sm" 
      fullWidth
      fullScreen={isMobile}
      PaperProps={{
        sx: {
          m: { xs: 0, sm: 2 },
          maxHeight: { xs: "100%", sm: "90vh" },
          width: { xs: "100%", sm: "auto" },
        }
      }}
    >
      <DialogTitle sx={{ 
        fontSize: { xs: "18px", sm: "20px", md: "24px" },
        py: { xs: 1.5, sm: 2 },
        fontWeight: 600,
      }}>
        ترحيل بين الخزن
      </DialogTitle>
      <DialogContent sx={{ p: { xs: 2, sm: 3 } }}>
        <Box sx={{ mt: { xs: 0.5, sm: 1 } }}>
          <Typography 
            variant={isMobile ? "subtitle1" : "h6"} 
            mb={{ xs: 1.5, sm: 2 }}
            sx={{ fontSize: { xs: "16px", sm: "18px", md: "20px" } }}
          >
            تسجيل عملية ترحيل
          </Typography>
          <Box display="flex" flexDirection="column" gap={{ xs: 1.5, sm: 2 }}>
            <FormControl 
              fullWidth
              size={isMobile ? "small" : "medium"}
            >
              <InputLabel sx={{ fontSize: { xs: "14px", sm: "16px" } }}>
                إلى البنك
              </InputLabel>
              <Select
                name="to_bank_id"
                value={formData.to_bank_id}
                onChange={handleChange}
                fullWidth
                sx={{ fontSize: { xs: "14px", sm: "16px" } }}
              >
                {banks
                  .filter((b) => b.id !== formData.from_bank_id)
                  .map((bank) => (
                    <MenuItem 
                      key={bank.id} 
                      value={bank.id}
                      sx={{ fontSize: { xs: "14px", sm: "16px" } }}
                    >
                      {bank.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
            <TextField
              label="المبلغ"
              name="amount"
              type="number"
              value={formData.amount}
              onChange={handleChange}
              fullWidth
              size={isMobile ? "small" : "medium"}
              InputLabelProps={{ 
                style: { fontSize: isMobile ? "14px" : "16px" } 
              }}
              InputProps={{
                style: { fontSize: isMobile ? "14px" : "16px" }
              }}
            />
            <TextField
              label="عنوان الترحيل"
              name="transfer_title"
              value={formData.transfer_title}
              onChange={handleChange}
              fullWidth
              size={isMobile ? "small" : "medium"}
              InputLabelProps={{ 
                style: { fontSize: isMobile ? "14px" : "16px" } 
              }}
              InputProps={{
                style: { fontSize: isMobile ? "14px" : "16px" }
              }}
            />
            <TextField
              label="وصف الترحيل"
              name="transfer_description"
              value={formData.transfer_description}
              onChange={handleChange}
              fullWidth
              multiline
              rows={isMobile ? 2 : 3}
              size={isMobile ? "small" : "medium"}
              InputLabelProps={{ 
                style: { fontSize: isMobile ? "14px" : "16px" } 
              }}
              InputProps={{
                style: { fontSize: isMobile ? "14px" : "16px" }
              }}
            />
            <TextField
              label="تاريخ العملية"
              name="transaction_date"
              type="date"
              value={formData.transaction_date}
              onChange={handleChange}
              InputLabelProps={{ 
                shrink: true, 
                style: { fontSize: isMobile ? "14px" : "16px" } 
              }}
              InputProps={{
                style: { fontSize: isMobile ? "14px" : "16px" }
              }}
              fullWidth
              size={isMobile ? "small" : "medium"}
            />
          </Box>
        </Box>
      </DialogContent>
      <DialogActions sx={{ 
        p: { xs: 2, sm: 2 },
        gap: { xs: 1, sm: 1 },
        flexDirection: { xs: "column-reverse", sm: "row" },
      }}>
        <Button 
          onClick={onClose}
          fullWidth={isMobile}
          size={isMobile ? "medium" : "large"}
          sx={{ fontSize: { xs: "14px", sm: "15px" } }}
        >
          إلغاء
        </Button>
        <Button 
          variant="contained" 
          color="primary" 
          onClick={handleSubmit}
          fullWidth={isMobile}
          size={isMobile ? "medium" : "large"}
          sx={{ fontSize: { xs: "14px", sm: "15px" } }}
        >
          تسجيل الترحيل
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TransfermonyModal;
